/**
 * HorseIcon — chess-knight silhouette (Font Awesome 6, solid).
 *
 * Chosen over a hand-crafted horse head because:
 *   - Chess knight = universally recognized as "horse"
 *   - Pairs with the Kingly crown/king brand for a cohesive royal chess set
 *   - Sharp, professional silhouette that scales cleanly from 16px → 44px
 *
 * Path from Font Awesome 6 Free (CC BY 4.0), viewBox 0 0 448 512.
 */
export default function HorseIcon({ size = 20, className = "", ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 448 512"
      fill="currentColor"
      stroke="none"
      className={className}
      aria-hidden="true"
      {...props}
    >
      <path d="M19 272.47l40.63 18.06a32 32 0 0 0 24.88.47l12.78-5.12a32 32 0 0 0 18.76-20.5l9.22-30.65a24 24 0 0 1 12.55-15.65L159.94 208v50.33a48 48 0 0 1-26.53 42.94l-57.22 28.65A80 80 0 0 0 32 401.48V416h319.86V224c0-106-85.92-192-191.92-192H12A12 12 0 0 0 0 44a16.9 16.9 0 0 0 1.79 7.58L16 80l-9 9a24 24 0 0 0-7 17v137.21a32 32 0 0 0 19 29.26zM52 128a20 20 0 1 1-20 20 20 20 0 0 1 20-20zm316 20a20 20 0 1 1-20 20 20 20 0 0 1 20-20z" />
    </svg>
  );
}
